<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
    </div>
    <div class="container text-left">
      <b-card>
        <div class="row">
          <div class="col-lg-6">
            <h1 style="display: inline; margin-right: 15px">Events</h1>
            <b-button class="btn btn-white btn-sm mb-1" v-if="!filtersShown"
              v-on:click="filtersShown = !filtersShown"><font-awesome-icon icon="chevron-down" /> Show Filters</b-button>
            <b-button class="btn btn-white btn-sm mb-1" v-if="filtersShown"
              v-on:click="filtersShown = !filtersShown"><font-awesome-icon icon="chevron-up" /> Hide Filters</b-button>
          </div>
          <div class="col-lg-6 text-right">
            <router-link class="radius btn btn-secondary mr-2" to="/events/create">Create Event</router-link>
            <b-button @click="downloadCSV()" :disabled="downloading" class="btn btn-white"><font-awesome-icon
                icon="download" /> Download CSV</b-button>
          </div>
        </div>
        <div class="row justify-content-md-start mt-3" v-show="filtersShown">
          <div class="col-lg-6">
            <div>
              <b-input-group prepend="Date Range">
                <b-select v-model="dateRangeText" @input="val => changeDateText(val)">
                  <option :value="null">Everything</option>
                  <optgroup label="Current">
                    <option value="this week">This Week</option>
                    <option value="this month">This Month</option>
                    <option value="this year">This Year</option>
                  </optgroup>
                  <optgroup label="Future">
                    <option value="next 60 days">Next 60 Days</option>
                    <option value="next year">Next Year</option>
                  </optgroup>
                  <optgroup label="Past">
                    <option value="last 10 days">Last 10 Days</option>
                    <option value="last 60 days">Last 60 Days</option>
                    <option value="last month">Last Month</option>
                  </optgroup>
                </b-select>
              </b-input-group>

              <b-input-group prepend="Start Date">
                <v-date-picker v-model="dateRange.start" :max-date="dateRange.end" />
              </b-input-group>

              <b-input-group prepend="End Date">
                <v-date-picker v-model="dateRange.end" :min-date="dateRange.start" />
              </b-input-group>

              <b-input-group prepend="Category">
                <b-select v-model="category">
                  <option :value="null">All</option>
                  <option value="Alabama Maker">Alabama Maker</option>
                  <option value="Arts and culture">Arts and culture</option>
                  <option value="BBQ">BBQ</option>
                  <option value="Business and networking">Business and networking</option>
                  <option value="Civic and local">Civic and local</option>
                  <option value="Civil Rights">Civil Rights</option>
                  <option value="Collectibles and special interest">Collectibles and special interest</option>
                  <option value="Community festival">Community festival</option>
                  <option value="Cultural festival">Cultural festival</option>
                  <option value="Education">Education</option>
                  <option value="Entertainment and nightlife">Entertainment and nightlife</option>
                  <option value="Food and drink">Food and drink</option>
                  <option value="Golf">Golf</option>
                  <option value="History and heritage">History and heritage</option>
                  <option value="Holiday and seasonal">Holiday and seasonal</option>
                  <option value="Music festival">Music festival</option>
                  <option value="Outdoor">Outdoor</option>
                  <option value="Shopping">Shopping</option>
                  <option value="Sports and recreation">Sports and recreation</option>
                </b-select>
              </b-input-group>
            </div>
          </div>
          <div class="col-lg-6">
            <div>
              <b-form-checkbox name="unclaimed" v-model="unclaimed">Unclaimed Events</b-form-checkbox>

              <b-input-group prepend="Publish">
                <b-select v-model="publish">
                  <option :value="null">All</option>
                  <option value="None">None</option>
                  <option value="Limited">Limited</option>
                  <option value="Everywhere">Everywhere</option>
                  <option value="Everywhere %2B Featured">Everywhere + Featured</option>
                </b-select>
              </b-input-group>

              <b-input-group prepend="Event Name">
                <b-form-input v-model="filter" />
              </b-input-group>

              <b-input-group>
                <b-button @click="search()">Search</b-button>
                <b-button @click="resetSearch()" class="ml-3 btn-white">Reset</b-button>
              </b-input-group>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-12 mt-2">
          <b-card>
            <div class="text-center mb-2 sort-wrapper">
              <span>
                Sorting By:
                <b>{{ sortField }}</b>, Sort Direction:
                <b>{{ $store.state.events.sort.direction === 'asc' ? 'Ascending' : 'Descending' }}</b>
              </span>
            </div>
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th @click="sort('name')" class="sort">
                      <span>Name <font-awesome-icon icon="sort" /></span>
                    </th>
                    <th @click="sort('city')" class="sort">
                      <span>City <font-awesome-icon icon="sort" /></span>
                    </th>
                    <th>Categories</th>
                    <th @click="sort('start_on')" class="sort">
                      <span>Start On <font-awesome-icon icon="sort" /></span>
                    </th>
                    <th @click="sort('end_on')" class="sort">
                      <span>End On <font-awesome-icon icon="sort" /></span>
                    </th>
                    <th @click="sort('publish')" class="sort">
                      <span>Publish <font-awesome-icon icon="sort" /></span>
                    </th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="event in $store.state.events.list" :key="event._id">
                    <td>
                      <router-link :to="{ name: 'event detail', params: { eventId: event._id } }" class="">
                        <template v-if="event.name.length <= 50">
                          {{ event.name }}
                        </template>
                        <template v-else>
                          {{ event.name.substring(0, 50) + '...' }}
                        </template>
                      </router-link>
                    </td>
                    <td>{{ event.city }}</td>
                    <td>
                      <div>{{ event.categories ? event.categories.join(', ') : null }}</div>
                    </td>
                    <td>{{ event.start_on | dateOnly }}</td>
                    <td>{{ event.end_on | dateOnly }}</td>
                    <td class="publish">
                      <b-select v-model="event.publish" @change="setPublishStatus(event, $event)" size="sm">
                        <option value="None">None</option>
                        <option value="Limited">Limited</option>
                        <option value="Everywhere">Everywhere</option>
                        <option value="Everywhere + Featured">Everywhere + Featured</option>
                      </b-select>
                    </td>
                    <td>
                      <router-link :to="{ name: 'event edit', params: { eventId: event._id } }"
                        class="btn btn-secondary event-link-btn">Edit</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination justify-content-end mt-5">
              <div class="total-count ml-2">Total Records: {{ $store.state.events.fullCount.toLocaleString() }}</div>
              <b-pagination v-if="$store.state.events.fullCount > 0" :value="$store.state.events.page.page"
                :total-rows="$store.state.events.fullCount" :per-page="$store.state.events.page.pageSize"
                :hide-ellipsis="true" @change="changePage" />
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  debugger
import axios from 'axios';
// import uuidv4 from 'uuid/v4';
import {
  addDays,
  addYears,
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfDay,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
} from 'date-fns';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BreadcrumbsHelper from '../../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      dateRangeText: '',
      dateRange: {
        start: null,
        end: null,
      },
      category: '',
      publish: '',
      unclaimed: false,
      filter: '',
      sortField: '',
      downloading: false,
      sortDict: {
        name: 'Name',
        city: 'City',
        start_on: 'Start On',
        end_on: 'End On',
        publish: 'Publish',
      },
      filtersShown: true,
      Breadcrumbs: [
        {
          text: 'Dashboard',
          active: false,
          href: '/admin',
        },
        {
          text: 'Partners',
          active: true,
        },
        {
          text: 'Events',
          active: true,
        },
      ],
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch('events/getEvents');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
    this.sortField = this.sortDict[this.$store.state.events.sort.field];
  },
  methods: {
    async setPublishStatus(event, e) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_EVENTS_ROOT}/updatePublishStatus/${event._id}/${e}`);
        this.$bvToast.toast(`${response.data}`, {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } catch (err) {
        this.$bvToast.toast('Event Publish Not Updated', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    changeDateText(selectedText) {
      switch (selectedText) {
        case 'this week':
          this.dateRange.start = startOfWeek(new Date());
          this.dateRange.end = endOfWeek(new Date());
          break;
        case 'this month':
          this.dateRange.start = startOfMonth(new Date());
          this.dateRange.end = endOfMonth(new Date());
          break;
        case 'this year':
          this.dateRange.start = startOfYear(new Date());
          this.dateRange.end = endOfYear(new Date());
          break;
        case 'next 60 days':
          this.dateRange.start = startOfDay(new Date());
          this.dateRange.end = addDays(startOfDay(new Date()), 60,);
          break;
        case 'next year':
          this.dateRange.start = startOfDay(new Date());
          this.dateRange.end = addYears(startOfDay(new Date()), 1);
          break;
        case 'last 10 days':
          this.dateRange.start = subDays(new Date(), 10);
          this.dateRange.end = new Date();
          break;
        case 'last 60 days':
          this.dateRange.start = subDays(new Date(), 60);
          this.dateRange.end = new Date();
          break;
        case 'last month':
          this.dateRange.start = subMonths(new Date(), 1);
          this.dateRange.end = endOfMonth(subMonths(new Date()), 1);
          break;
        default:
          this.dateRange.start = null;
          this.dateRange.end = null;
          break;
      }

      this.$store.commit('events/setDateRange', this.dateRange);
    },
    async search() {
      try {
        this.isLoading = true;
        this.$store.commit('events/setDateRange', this.dateRange);
        this.$store.commit('events/setCategory', this.category);
        this.$store.commit('events/setPublish', this.publish);
        this.$store.commit('events/setUnclaimed', this.unclaimed);
        this.$store.commit('events/setFilter', this.filter);
        await this.$store.dispatch('events/sortEventsAscending', 'start_on');
        this.sortField = this.sortDict.start_on;
        await this.$store.dispatch('events/getEvents');
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async resetSearch() {
      try {
        this.isLoading = true;
        this.$store.dispatch('events/resetFilters');
        this.dateRangeText = '';
        this.dateRange = {
          start: null,
          end: null,
        };
        this.category = '';
        this.publish = '';
        this.unclaimed = false;
        this.filter = '';
        await this.$store.dispatch('events/sortEventsAscending', 'start_on');
        this.sortField = this.sortDict.start_on;
        await this.$store.dispatch('events/getEvents');
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async sort(field) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('events/sortEvents', field);
        this.sortField = this.sortDict[field];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async changePage(page) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('events/setPage', page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async getSignedUrl(uuid, waitTime) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_EVENTS_ROOT}/download/getSignedUrl/${uuid}`);
        this.forceFileDownload(response.data);
      } catch (err) {
        let newWaitTime = Math.floor(waitTime * 1.3);
        if (newWaitTime > 10000) newWaitTime = 10000;
        setTimeout(() => this.getSignedUrl(uuid, newWaitTime), newWaitTime);
      }
    },
    async downloadCSV() {
      const query = { ...this.$store.state.events };
      let url = `${process.env.VUE_APP_API_EVENTS_ROOT}/events?csv=true`;
      if (query.sort.field) {
        url += `&sorting=true&sortField=${query.sort.field}&sortDirection=${query.sort.direction}`;
      }
      if (query.filter && query.filter !== '') {
        url += `&filtering=true&filter=${query.filter}`;
      }
      if (query.category && query.category !== '') {
        url += `&category=${query.category}`;
      }
      if (query.publish && query.publish !== '') {
        url += `&publish=${query.publish}`;
      }
      if (query.dateRange.start) {
        url += `&startDate=${query.dateRange.start}`;
      }
      if (query.dateRange.end) {
        url += `&endDate=${query.dateRange.end}`;
      }

      try {
        document.body.style.cursor = 'wait';
        this.downloading = true;
        await axios({
          method: 'get',
          url,
          responseType: 'blob',
        }).then((response) => {
          const url2 = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url2;
          link.setAttribute('download', 'events.csv'); // or any other extension
          document.body.appendChild(link);
          link.click();
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.downloading = false;
        document.body.style.cursor = 'default';
      }
    },
  },
};
</script>

<style scoped>
.publish {
  width: 110px;
}

.input-group {
  padding: 5px 0px;
  width: 100%;
}

.event-link-btn {
  min-width: 60px;
  margin-bottom: 5px;
}

.input-group-prepend,
.input-group-append {
  width: 110px;
}

.input-group-text {
  width: 100%;
}

.table-sm td {
  padding: 0.75rem;
}

.total-count {
  padding-right: 20px;
  line-height: 36px;
}

.summary {
  max-height: 100px;
}

td div {
  max-height: 165px !important;
  overflow: hidden !important;
}

.container-fluid {
  padding-left: 50px !important;
  padding-right: 50px !important;
}

.card {
  border: none;
}

.sort-wrapper span {
  background-color: #f5ecca;
  padding: 5px 10px;
  border-radius: var(--rounded-md);
  margin-bottom: 5px;
  display: inline-block;
}

th.sort span {
  cursor: pointer;
}

.fa-sort {
  color: #ccc;
}

table thead th {
  white-space: nowrap;
}
</style>
